import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f5eb0b08"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "mission_bigbox"
};

var _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-f5eb0b08><div class=\"mission_box col-lg-12 col-md-12 col-sm-12 col-xs-12\" data-v-f5eb0b08><div class=\"mission_title\" data-v-f5eb0b08> Our Mission </div><div class=\"mission_content\" data-v-f5eb0b08><div class=\"mission_left_line\" data-v-f5eb0b08></div><div class=\"mission_text_index\" data-v-f5eb0b08> Tenacity in Neuroscience, Innovate for Life. </div><div class=\"mission_right_line\" data-v-f5eb0b08></div></div></div></div>", 1);

var _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}